// extracted by mini-css-extract-plugin
export default {"main":"home_main__szT0-","project_container":"home_project_container__veATR","yet_implement":"home_yet_implement__+x9vW"};